export default __webpack_public_path__ + "static/media/howItworks.fe05cddc.jpg";